// extracted by mini-css-extract-plugin
module.exports = {"container":"BotOverallPerformance_container__1mV1j","infoList":"BotOverallPerformance_infoList__3KT6P","infoItem":"BotOverallPerformance_infoItem__29ldq"};